// extracted by mini-css-extract-plugin
export default {"button":"Button_button__dxrcN","primary":"Button_primary__imuNk","outline":"Button_outline__nrOQY","danger":"Button_danger__9XohM"};